/* eslint-disable no-useless-escape */
/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/no-did-update-set-state */
/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable react/no-array-index-key */
/* eslint-disable max-len */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-empty */
import React from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import { Link } from 'react-router-dom';
import { Tooltip } from 'react-tippy';

import { faBug, faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import pageTitleService from '../app/services/pageTitle';
import tagManager from '../app/services/tagManager';
import { cartAddItem, cartAddItemCache } from '../app/store/actions/cart';
import { favoritesRemoveItem, setProductsFavorites } from '../app/store/actions/favorites';
import { getProductDetails, getProductsRecommended } from '../app/store/actions/products';
import ProductsUtil from '../app/utils/products';
import FinalPriceComponent from '../components/price/FinalPrice';
import PriceComponent from '../components/price/Price';
import ProductItem from '../components/productElements/ProductItem';
import ProductFeedback from '../components/productFeedback/productFeedback';
import ProductLeadTimeModal from '../components/productLeadTimeModal';
import { appendScript, removeScript } from '../components/utils';
import inputSize from '../data/inputs';
import ProductsData from '../data/products';
import ROUTES from '../data/routes';
import NumberHelper from '../helpers/number';
import validator from '../helpers/validators';
import { history } from '../routers/AppRouter';
import Breadcrumb from '../components/breadcrumb/Breadcrumb';

export class ProductPage extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      amount: 1,
      mandatoryQuantity: '',
      multipleQuantity: 1,
      isAmountInvalid: false,
      showModalProductFeedback: false,
      maxRecommended: ProductsData.maxRecommendedCarouselTabs,
      showLeadTimeModal: false,
    };
  }

  componentDidMount = () => {
    setTimeout(async () => {
      const prevHead = {
        title: pageTitleService.getTitle(),
        hardDescription: pageTitleService.getHardDescription(),
        hardKeywords: pageTitleService.getHardKeywords(),
        ogSitename: pageTitleService.getOgSitename(),
        description: pageTitleService.getDescription(),
        image: pageTitleService.getImage(),
      };

      window.scrollTo(0, 0);

      try {
        const { match, settings } = this.props;
        const { id, code } = match.params;
        const product = await this.props.getProduct(id, code);
        await this.props.getProductsRecommended();
        let companyName = '';

        if (settings) {
          if (settings.name) companyName = settings.name;
        }

        pageTitleService.setTitle(ProductsUtil.getResume(product));
        pageTitleService.setHardDescription(product.textMarketing || product.name);
        pageTitleService.setHardKeywords(ProductsUtil.getKeywords(product));
        pageTitleService.setOgSitename(`${companyName} eShop`.trim());
        pageTitleService.setDescription(product.descriptionEcommerce || product.name);
        pageTitleService.setImage(product.image);

        this.setState({
          product,
          prevHead,
          amount: product.multipleQuantity || 1,
        });

        removeScript('/scripts/product.min.js');
        appendScript('/scripts/product.min.js');

        this.updateInterval = setTimeout(this.updatePromotionCoutdown, 1000);
      } catch (e) { }

      this.setState({
        showProduct: true,
      });

      this.onViewPage();
    }, 0);
  }

  componentDidUpdate = async () => {
    const { product = {}, multipleQuantity } = this.state;
    if (product && (product.multipleQuantity !== multipleQuantity)) {
      this.setState({
        multipleQuantity: product.multipleQuantity || 1,
        amount: product.multipleQuantity || 1,
      });
    }
  }

  openOrCloseModalProductFeedback = () => {
    const { showModalProductFeedback } = this.state;
    this.setState({ showModalProductFeedback: !showModalProductFeedback });
  }

  openOrCloseLeadTimeModal = async () => {
    await this.setState(prevState => ({
      ...prevState,
      showLeadTimeModal: !prevState.showLeadTimeModal,
    }));
  }

  componentWillUnmount = () => {
    try {
      const { prevHead } = this.state;

      pageTitleService.setTitle(prevHead.title);
      pageTitleService.setHardDescription(prevHead.hardDescription);
      pageTitleService.setHardKeywords(prevHead.hardKeywords);
      pageTitleService.setOgSitename(prevHead.ogSitename);
      pageTitleService.setDescription(prevHead.description);
      pageTitleService.setImage(prevHead.image);

      clearTimeout(this.updateInterval);
    } catch (e) { }
    removeScript('/scripts/product.min.js');
  }

  componentWillReceiveProps = async (nextProps) => {
    if (nextProps.contractId !== this.props.contractId) {
      await this.props.getProductsRecommended(true);
      removeScript('/scripts/product.min.js');
      appendScript('/scripts/product.min.js');
    }
  }

  onViewPage = async () => {
    try {
      const productsToSend = [];
      const {
        product,
      } = this.state;

      productsToSend.push({
        name: product.name,
        id: product.code,
        price: `${product.price ? (product.price.value || 0) : 0}`,
        brand: product.brand ? product.brand.description : '',
        category: product.category ? product.category.name : '',
      });

      tagManager.ecommerceDetail(productsToSend);
    } catch (err) { }
  }

  getDescription = (product = {}, displayClientDescription = false) => {
    if (product.textMarketing) return product.textMarketing;
    if (product.descriptionEcommerce) return product.descriptionEcommerce;
    if (displayClientDescription && product.clientDescription) return product.clientDescription;

    return product.name;
  }

  getDescriptionResume = (product = {}, displayClientDescription = false) => {
    if (displayClientDescription && product.clientDescription) return product.clientDescription;
    if (product.descriptionEcommerce) return product.descriptionEcommerce;

    return '';
  }

  renderTopImagesSwiper = (images = [], product = {}) => {
    if (!images.length) {
      return (
        <div key="0" className="swiper-slide">
          <a href="/images/product-image-placeholder.png" data-fancybox="produto">
            <img src="/images/product-image-placeholder.png" alt={product.name} />
          </a>
          <p style={{ textAlign: 'end', paddingBottom: '4px' }}>
            <strong style={{ fontWeight: '600', fontSize: '14px' }}>{I18n.t('imageIllustrative')}</strong>
          </p>
        </div>
      );
    }
    return (
      images.map((image, index) => (
        <div key={`${image}${index}`} className="swiper-slide">
          <a href={image || '/images/product-image-placeholder.png'} data-fancybox="produto">
            <img src={image || '/images/product-image-placeholder.png'} alt={product.name} />
          </a>
          <p style={{ textAlign: 'end', paddingBottom: '4px' }}>
            <strong style={{ fontWeight: '600', fontSize: '14px' }}>{I18n.t('imageIllustrative')}</strong>
          </p>
        </div>
      ))
    );
  }

  renderBottomImagesSwiper = (images = [], product = {}) => (
    images.map((image, index) => (
      <div key={`${image}${index}`} className="swiper-slide">
        <img src={image || '/images/product-image-placeholder.png'} alt={product.name} />
      </div>
    ))
  )

  renderDatasheet = (pdmParticulars = []) => (
    !!pdmParticulars.length && (
      <div className="product-datasheet">
        <h2 className="title">{I18n.t('productDatasheet')}</h2>
        {pdmParticulars.map(pdm => (
          <p key={pdm.id}>
            {pdm.id}
            {': '}
            <strong>{pdm.value}</strong>
          </p>
        ))}
      </div>
    )
  )

  renderDatasheetDocs = (datasheets = []) => (
    !!datasheets.length && (
      <div className="product-materials">
        <h2 className="title">{I18n.t('productDatasheetAvailable')}</h2>
        <ul>
          {datasheets.map(datasheet => (
            <li key={datasheet}>
              {I18n.t('productDatasheetDetails')}
              <a className="pdf" href={datasheet} target="_blank">
                <svg className="icon icon-dowload"><use xlinkHref="#icon-dowload" /></svg>
                {' '}
                {I18n.t('downloadPdf')}
              </a>
            </li>
          ))}
        </ul>
      </div>
    )
  )

  // ##### RIGHT SIDE RESUME #####
  updatePromotionCoutdown = async () => {
    const { product = {} } = this.state;
    if (product.price && !product.price.isContract && product.price.finalizedAt) {
      const promotionCoutdown = ProductsUtil.getPromotionCountdown(product.price);
      await this.setState({ promotionCoutdown });
      this.updateInterval = setTimeout(this.updatePromotionCoutdown, 1000);
    }
  };

  formatTotal = value => value && Number(value).toFixed(NumberHelper.countDecimals(this.state.multipleQuantity));

  handleAmount = async (value) => {
    const { amount } = this.state;

    const valDecCount = (amount.toString().split('.')[1] || '').length;
    const stepDecCount = (value.toString().split('.')[1] || '').length;
    const decCount = valDecCount > stepDecCount ? valDecCount : stepDecCount;
    let valInt = parseInt(Number(amount).toFixed(decCount).replace('.', ''), 0);
    valInt = valInt <= 0 ? valInt * -1 : valInt;
    const stepInt = parseInt(Number(value).toFixed(decCount).replace('.', ''), 0);
    const qtd = ((valInt + stepInt) / (10 ** decCount));

    await this.handleSetAmount(qtd, false);
  };

  formatCpnjCpf = (value, opcoRegisterCPF) => {
    if (opcoRegisterCPF && value.length <= 11) {
      return value.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, '\$1.\$2.\$3\-\$4');
    }

    return value.substring(0, 14).replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g, '\$1.\$2.\$3\/\$4\-\$5');
  }

  handleStock = () => {
    const { product } = this.state;
    const deps = product.allStocks.sort(d => (d.mainDeposit ? -1 : 1));

    return deps.map((item, index) => (
      <div key={`deposits${item.branchName}${index}`} className="_detail _detail __stocks">
        <div>
          <span className="_text" style={{ fontSize: '9px' }}>
            {`${(item.city ? (`${item.city} - `) : '')}${(item.cgc ? this.formatCpnjCpf(item.cgc, true) : '')} `}
          </span>
        </div>
        <span className="_value">
          {item.availableQuantity}
        </span>
      </div>
    ));
  };

  handleStockLot = () => {
    const { product } = this.state;
    return product.lot.map(element => (
      <div key={`depositsByBranchCode${element.branchCode}`} className="_detail _detail __stocks">
        <span className="_text" style={{ fontSize: '9px' }}>
          {`${(element.city ? (`${element.city} - `) : '')}${(element.cgc ? this.formatCpnjCpf(element.cgc, true) : '')} `}
        </span>
        <span className="_value">{element.allQuantity}</span>
        <span className="_text" style={{ width: '70%' }} />
        <span className="_value" style={{ width: '30%' }}>
          {I18n.t('BidAvailable')}
        </span>
        {element.lots.map(elem => (
          <React.Fragment key={`lots${elem.lot}${element.branchCode}`}>
            <span className="_text" style={{ width: '70%' }} />
            <span className="_value" style={{ width: '30%' }}>
              {elem.quantity}
            </span>
          </React.Fragment>
        ))}
      </div>
    ));
  };

  totalLotQuantity = () => this.state.product.lot.reduce((totalAmount, element) => totalAmount += element.allQuantity,
    0);


  handleSetAmount = async (value, checkDecimals = true) => {
    const { product } = this.state;
    const { allowSellSpotItensWithoutStock } = this.props;
    if (value === '') await this.setState({ amount: '' });
    else if (!isNaN(value)) {
      const countedDecimals = NumberHelper.countDecimals(this.state.multipleQuantity);
      if (countedDecimals > 0 && checkDecimals) {
        value = Number(value.toString().replace(/\D+/g, ''))
          / (10 ** countedDecimals);
      }
      value = value < 0 ? 0 : value;
      if (value % 1 === 0 && countedDecimals === 0) {
        const modValue = value % product.multipleQuantity;
        if (modValue !== 0) value -= modValue;
      }
      await this.setState({ amount: value });
    }

    if (validator.isSpotProductAmountInvalid(value,
      product.stock, allowSellSpotItensWithoutStock, product.isSpot, product.price.isContract)) {
      this.setState({
        isAmountInvalid: true,
      });
    } else {
      this.setState({
        isAmountInvalid: false,
      });
    }

    this.onChangeMandatoryQuantity(this.state.mandatoryQuantity);
  };

  onChangeMandatoryQuantity = (value) => {
    let { mandatoryQuantity } = this.state;

    if (!value) {
      mandatoryQuantity = '';
    } else if (!isNaN(`${value}`.replace(/\.|,| /g, 'x'))) {
      if (parseFloat(value) <= parseFloat(this.state.amount)) {
        mandatoryQuantity = Number(value);
      } else {
        mandatoryQuantity = parseFloat(this.state.amount);
      }
    }
    this.setState({ mandatoryQuantity });
  };

  addProductToCart = async () => {
    const {
      multipleQuantity, amount, product = {}, mandatoryQuantity,
    } = this.state;
    const { isAuthenticated } = this.props;
    const isAmountValid = this.validateCardProducts(product.id);
    if (!isAuthenticated) {
      await this.props.addItemCache(product.id, amount, mandatoryQuantity);
      this.setState({
        isAmountInvalid: false,
      });

      if (this.props.headerRef && this.props.headerRef.current) {
        this.props.headerRef.current.openCartMenu();
      }
    } else if (isAmountValid) {
      const value = amount - (this.floatSafeModulus(amount, multipleQuantity));
      if (product.id) await this.props.addItem(product.id, product.clientCode, value, product.code, mandatoryQuantity);
      this.setState({
        isAmountInvalid: false,
      });
      history.push(ROUTES.CART);
    } else {
      this.setState({
        isAmountInvalid: true,
      });
    }
  };

  productToFavorite = async () => {
    const { product = {}, amount } = this.state;
    const { isAuthenticated, favoritesItems } = this.props;
    const favorite = favoritesItems.find(fav => `${fav.productId}` === product.code);

    if (isAuthenticated) {
      if (favorite) {
        await this.props.favoritesRemoveItem(favorite.id, favorite.clientId);
      } else {
        await this.props.setProductsFavorites(product.id, product.code, product.clientCode, amount);
      }
    }
  }

  validateCardProducts = (id) => {
    const { cartItems, allowSellSpotItensWithoutStock } = this.props;
    const { amount, product = {} } = this.state;

    const productInCart = cartItems.find(item => item.product.id === id);

    if (productInCart && validator.isSpotProductAmountInvalid((Number(amount) + Number(productInCart.total)),
      product.stock, allowSellSpotItensWithoutStock, product.isSpot, product.price.isContract)) {
      return false;
    }
    return true;
  }

  floatSafeModulus = (val, step) => {
    if (val && val !== '0') {
      const valDecCount = (val.toString().split('.')[1] || '').length;
      const stepDecCount = (step.toString().split('.')[1] || '').length;
      const decCount = valDecCount > stepDecCount ? valDecCount : stepDecCount;
      const valInt = parseInt(Number(val).toFixed(decCount).replace('.', ''), 0);
      const stepInt = parseInt(Number(step).toFixed(decCount).replace('.', ''), 0);
      return (((valInt % stepInt) + stepInt) % stepInt) / (10 ** decCount);
    }
    return 1;
  }

  renderRatings = (ratings = []) => (
    !!ratings.length && (
      <div className="product-reviews">
        <h2 className="title">{`${I18n.t('productRatings')} (${ratings.length})`}</h2>
        <div className="review">
          <div className="rating">
            <svg className="icon icon-rating icon--active"><use xlinkHref="#icon-rating" /></svg>
            <svg className="icon icon-rating icon--active"><use xlinkHref="#icon-rating" /></svg>
            <svg className="icon icon-rating icon--active"><use xlinkHref="#icon-rating" /></svg>
            <svg className="icon icon-rating icon--active"><use xlinkHref="#icon-rating" /></svg>
            <svg className="icon icon-rating"><use xlinkHref="#icon-rating" /></svg>
          </div>
          <p>
            ut placerat orci nulla pellentesque dignissim enim sit amet venenatis urna cursus eget nunc scelerisque viverra mauris in aliquam sem
          </p>
          <span className="name">Marcelo Abreu</span>
          <span className="data">há 5 dias</span>
        </div>
        <div className="review">
          <div className="rating">
            <svg className="icon icon-rating icon--active"><use xlinkHref="#icon-rating" /></svg>
            <svg className="icon icon-rating"><use xlinkHref="#icon-rating" /></svg>
            <svg className="icon icon-rating"><use xlinkHref="#icon-rating" /></svg>
            <svg className="icon icon-rating"><use xlinkHref="#icon-rating" /></svg>
            <svg className="icon icon-rating"><use xlinkHref="#icon-rating" /></svg>
          </div>
          <p>
            ut placerat orci nulla pellentesque dignissim enim sit amet venenatis urna cursus eget nunc scelerisque viverra mauris in aliquam sem
          </p>
          <span className="name">Marcelo Abreu</span>
          <span className="data">há 5 dias</span>
        </div>
        <a className="btn-review" href="#">DEIXAR UMA AVALIAÇÃO</a>
      </div>
    )
  )

  renderRecommended = (products = []) => (
    <div className="section">
      <div className="container">
        <span className="section__title">{I18n.t('productRecommended')}</span>

        <div className="product-recommended">

          <div className="product-recommended__filter">
            <a className="filter active" data-filter="todos">{I18n.t('all').toUpperCase()}</a>
            {products.reduce((ctg, value) => {
              if (ctg.length <= this.state.maxRecommended && (ctg.findIndex(el => el.id === value.category.id) === -1)) ctg.push(value.category);
              return ctg;
            }, []).map(categ => (<a key={categ.name} className="filter" data-filter={categ.id}>{categ.name.toUpperCase()}</a>))}
          </div>

          <div className="swiper-product-recommended swiper-container">
            <div className="swiper-wrapper">
              {products.map(product => (
                <div key={`${product.id}${product.category.id}`} className="swiper-slide" data-category={product.category.id}>
                  <ProductItem product={product} headerRef={this.props.headerRef} />
                </div>
              ))}
            </div>
          </div>
          <div className="swiper-product-recommended-prev"><svg className="icon icon-arrow-left"><use xlinkHref="#icon-arrow-left" /></svg></div>
          <div className="swiper-product-recommended-next"><svg className="icon icon-arrow-right"><use xlinkHref="#icon-arrow-right" /></svg></div>
        </div>
      </div>
    </div>
  )

  render() {
    const {
      product = {}, showProduct = false, mandatoryQuantity,
      amount, multipleQuantity, promotionCoutdown, isAmountInvalid,
      showModalProductFeedback, showLeadTimeModal,
    } = this.state;
    const { category = {} } = product;
    const {
      displayClientDescription = false, soneparCodeOff,
      leadTimePermission, stockPermission, cartPermission,
      pricePermission, opicCodePermission, soneparCodePermission, portfolioGreen,
      allowSellSpotItensWithoutStock, isPunchOut, isAuthenticated, productsRecommended, favoritesItems,
    } = this.props;

    const isSpotProductInvalidToSell = (!allowSellSpotItensWithoutStock && !product.stock);

    const addToCartDisabled = (isAmountInvalid
      || (this.floatSafeModulus(amount, multipleQuantity) !== 0)
      || !amount || amount === 0);

    const isContract = (product.price && product.price.isContract && product.price.type === 'contract');
    const isAgreement = (product.price && product.price.isContract && product.price.type === 'agreement');
    const isDiscount = (product.price && !product.price.isContract && product.price.discount);
    const isContactUs = (!product.stock && product.price && product.price.contactUs);
    const isWithoutStock = (product.isSpot && product.price && !product.price.isContract && !product.stock);
    const isWithoutStockAllowSell = (product.isSpot && !product.price.isContract && !allowSellSpotItensWithoutStock && !product.stock);
    const isLeadTime = (leadTimePermission && (!product.stock || product.stock < amount));

    const showBuyButton = (isPunchOut || (!product.isSpot
      || product.price.isContract
      || (product.isSpot && !isSpotProductInvalidToSell))
      || !isAuthenticated)
      && (!isContactUs && !isWithoutStockAllowSell);

    const favoriteBool = favoritesItems.find(fav => `${fav.productId}` === product.code);
    const styleFavorite = favoriteBool ? '#icon-rating' : '#icon-star';

    const {
      id: productCode = null, code: productClientCode = null,
    } = (this.props.match && this.props.match.params) || {};

    const stock = product && product.stock;

    return (
      <main style={{ visibility: showProduct ? 'visible' : 'hidden' }}>
        <div className="breadcrumb-container">
          <Breadcrumb
            items={[
              {
                link: `/produtos?categories=${category.id}`,
                value: category.name,
              },
              {
                value: product.name,
              },
            ]}
          />
        </div>
        <div className="section section-product">
          <div className="container container-product">
            <div className="product-coll product-coll--right">
              <div className="product-gallery" style={{ borderRadius: '6px' }}>
                {isAuthenticated && (
                  <a className="favorite cursorPointer" onClick={this.productToFavorite}>
                    <svg className="icon icon-favorite"><use xlinkHref={styleFavorite} /></svg>
                  </a>
                )}

                <div className="swiper-product-gallery swiper-container">
                  <div className="swiper-wrapper">
                    {this.renderTopImagesSwiper(product.images, product)}
                  </div>
                  <div className="swiper-product-gallery-prev"><svg className="icon icon-arrow-left"><use xlinkHref="#icon-arrow-left" /></svg></div>
                  <div className="swiper-product-gallery-next"><svg className="icon icon-arrow-right"><use xlinkHref="#icon-arrow-right" /></svg></div>
                </div>
                <div className="swiper-product-gallery-thumbs swiper-container">
                  <div className="swiper-wrapper">
                    {this.renderBottomImagesSwiper(product.images, product)}
                  </div>
                </div>
              </div>

              {this.renderDatasheet(product.pdmParticulars)}

              <div className="product-description">
                <h2 className="title">{I18n.t('description')}</h2>
                <p>
                  {this.getDescription(product, displayClientDescription)}
                </p>
              </div>
              {this.renderDatasheetDocs(product.datasheet)}
              {/* this.renderRatings(product.datasheet) */}
            </div>
            <div className="product-coll product-coll--left">
              <div className="product-about" id="about">
                <span className="code">
                  {opicCodePermission && product.code && `( ${I18n.t('code2')} ${product.code} ) `}
                  {product.clientCode && `( ${I18n.t('clientCode')} ${product.clientCode} ) `}
                  {soneparCodePermission
                    && (!soneparCodeOff && product.id) && `( ${I18n.t('soneparCode')} ${product.id} ) `}
                </span>
                <h1 className="name">
                  {product.name}
                  {/* <div className="rating">
                    <svg className="icon icon-rating icon--active"><use xlinkHref="#icon-rating" /></svg>
                    <svg className="icon icon-rating"><use xlinkHref="#icon-rating" /></svg>
                    <svg className="icon icon-rating"><use xlinkHref="#icon-rating" /></svg>
                    <svg className="icon icon-rating"><use xlinkHref="#icon-rating" /></svg>
                    <svg className="icon icon-rating"><use xlinkHref="#icon-rating" /></svg>
                  </div> */}
                </h1>
                <span className="brand">
                  {ProductsUtil.getResume(product)}
                </span>
                <p className="description">
                  {this.getDescriptionResume(product, displayClientDescription)}
                </p>

                <div className="product-group-seals">
                  {product.descriptionGreen && (
                    <div className="descriptionGreenDiv">
                      <span
                        className="descriptionGreen descriptionGreenItem"
                        style={{ backgroundImage: `url(${portfolioGreen || '/images/product-image-placeholder.png'})` }}
                        alt={product.descriptionGreen}
                      >
                        <span className="tooltip">
                          {product.descriptionGreen}
                        </span>
                      </span>
                    </div>
                  )}
                  {isContract && (
                    <span className="product-seals contrato">{I18n.t('contract')}</span>
                  )}
                  {isAgreement && (
                    <span className="product-seals acordo">{I18n.t('agreement')}</span>
                  )}
                  {isDiscount && (
                    <span className="product-seals desconto">{`-${ProductsUtil.getDiscount(product.price)}`}</span>
                  )}
                  {(isWithoutStock || isContactUs) && (
                    <span className="product-seals estoque">{ProductsUtil.getStockAvailable(product.stock)}</span>
                  )}
                  {(isWithoutStock || isContactUs) && (
                    <span className="product-seals estoque">{I18n.t('consultUs')}</span>
                  )}
                  {isLeadTime && (
                    <span className="product-seals time">{ProductsUtil.getStockTime(product.leadTime)}</span>
                  )}
                </div>

                {product.price && !product.price.isContract && product.price.oldValue && (
                  <span className="price-old"><PriceComponent value={product.price.oldValue} /></span>
                )}
                {product.price && pricePermission && (
                  <span className="price">
                    <span className="ico-bar" />
                    {' '}
                    <FinalPriceComponent price={product.price} />
                  </span>
                )}
                {/* product.price && !product.price.isContract && product.price.discount && (
                  <span className="product-label label-hot-details">
                    {'-'}
                    {ProductsUtil.getDiscount(product.price)}
                  </span>
                ) */}

                {(isPunchOut || cartPermission || !isAuthenticated) && (
                  <React.Fragment>
                    {showBuyButton && (
                      <React.Fragment>
                        <div className="product-add">
                          <button className="product-add__less" type="button" onClick={() => this.handleAmount(-multipleQuantity)}>-</button>
                          <input
                            className="product-add__qnt"
                            type="text"
                            maxLength={inputSize.maxDefault}
                            value={this.formatTotal(amount) || '0'}
                            onChange={e => this.handleSetAmount(e.target.value)}
                          />
                          <button className="product-add__more" type="button" onClick={() => this.handleAmount(+multipleQuantity)}>+</button>
                        </div>
                        <a
                          className="product-cart"
                          style={{ cursor: 'pointer', borderRadius: '10px' }}
                          onClick={addToCartDisabled ? () => false : this.addProductToCart}
                          disabled={addToCartDisabled}
                        >
                          <svg className="icon icon-cart"><use xlinkHref="#icon-cart" /></svg>
                          {I18n.t('productCartAdd').toUpperCase()}
                        </a>
                      </React.Fragment>
                    )}
                    {product.controlLot && (
                      <React.Fragment>
                        <br />
                        <br />
                        <div style={{ width: '150px' }}>
                          <Tooltip
                            arrow
                            title={I18n.t('bidSizeInformative')}
                          >
                            <p className="mandatoryQuantityInformative">{I18n.t('bidSize')}</p>
                          </Tooltip>
                        </div>
                        <input
                          type="text"
                          className="mandatoryQuantityInput"
                          maxLength={inputSize.maxDefault}
                          value={mandatoryQuantity}
                          onChange={e => this.onChangeMandatoryQuantity(e.target.value)}
                        />
                        <br />
                      </React.Fragment>
                    )}
                    <p className="description" />
                    {isSpotProductInvalidToSell
                      && !!product.price && product.price.hasPrice
                      && !product.price.isContract
                      && (<p className="stock">{I18n.t('unavailable')}</p>)}

                    {isAuthenticated && isAmountInvalid && (
                      <p className="stock">
                        {`${I18n.t('invalidAmount2') + product.stock}
                        ${product.unit} ${I18n.t('invalidAmount3')} ${this.props.opicPhone}`}
                      </p>
                    )}

                    {!isWithoutStock && product.allStocks && product.allStocks.filter(dep => (dep.mainDeposit === true && dep.availableQuantity === 0)).length > 0 && (
                      <p className="stock">
                        {I18n.t('zeroedStockMain')}
                      </p>
                    )}

                    {this.floatSafeModulus(amount, multipleQuantity) !== 0 && (
                      <p className="stock">
                        {I18n.t('sellMultipleNeeds') + multipleQuantity}
                      </p>
                    )}
                    <span className="stock">{ProductsUtil.getUnitOptions(product)}</span>
                  </React.Fragment>
                )}
                {isAuthenticated && (
                  <div style={{ paddingBottom: '30px' }}>
                    <span
                      className="reportProblem"
                      onClick={() => this.openOrCloseModalProductFeedback()}
                    >
                      <FontAwesomeIcon style={{ paddingRight: '5px' }} icon={faBug} />
                      {I18n.t('reportProblem')}
                    </span>
                  </div>
                )}
                <div className="container-flex">
                  <span className="_text_stock">
                    {`${I18n.t('productStock')}:`}
                  </span>
                  <div className="container-flex-item side-stocks">
                    {product && stockPermission && product.stock ? (
                      product.controlLot && product.lot.length ? (
                        <div className="stock">
                          {this.handleStockLot()}
                          <div className="_detail __stocks">
                            <span className="_text">{I18n.t('productTotalStock')}</span>
                            <span className="_value">
                              {this.totalLotQuantity()}
                            </span>
                          </div>
                          {isAuthenticated && (
                            <div style={{ textAlign: 'end', marginTop: '10px' }}>
                              <span
                                className="reportProblem"
                                onClick={() => this.openOrCloseLeadTimeModal()}
                              >
                                <FontAwesomeIcon style={{ paddingRight: '5px' }} icon={faInfoCircle} />
                                {I18n.t('quantityDoesNotSuitMe')}
                              </span>
                            </div>
                          )}
                        </div>
                      ) : (
                        <div className="stock">
                          {this.handleStock()}
                          <div className="_detail __stocks">
                            <span className="_text">{I18n.t('productTotalStock')}</span>
                            <span className="_value">
                              {ProductsUtil.getStockAvailable(product.stock)}
                            </span>
                          </div>
                          {isAuthenticated && (
                            <div style={{ textAlign: 'end', marginTop: '10px' }}>
                              <span
                                className="reportProblem"
                                onClick={() => this.openOrCloseLeadTimeModal()}
                              >
                                <FontAwesomeIcon style={{ paddingRight: '5px' }} icon={faInfoCircle} />
                                {I18n.t('quantityDoesNotSuitMe')}
                              </span>
                            </div>
                          )}
                        </div>
                      )
                    ) : (
                      <div style={{ marginBottom: 30 }} />
                    )}
                  </div>
                </div>
                <div className="share">
                  {I18n.t('productShare')}
                  <a className="shared share__whatsapp" href={`https://wa.me/?text=${product.name} - ${window.location.href}`} target="_blank">
                    <svg className="icon icon-whatsapp"><use xlinkHref="#icon-whatsapp" /></svg>
                  </a>
                  <a className="shared share__facebook" href={`https://www.facebook.com/sharer?u=${window.location.href}&t=${product.name}`} target="_blank">
                    <svg className="icon icon-facebook"><use xlinkHref="#icon-facebook" /></svg>
                  </a>
                  <a className="shared share__linkedin" href={`https://www.linkedin.com/shareArticle?mini=true&url=${window.location.href}&title=${product.name}&summary=&source=Nortel`} target="_blank">
                    <svg className="icon icon-linkedin"><use xlinkHref="#icon-linkedin" /></svg>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div id="about-end" />
        </div>
        <ProductFeedback
          productSoneparId={product.id}
          showModalProductFeedback={showModalProductFeedback}
          closeProductFeedback={() => this.openOrCloseModalProductFeedback()}
        />
        <ProductLeadTimeModal
          showModal={showLeadTimeModal}
          openOrCloseModal={() => this.openOrCloseLeadTimeModal()}
          productCode={productCode}
          productClientCode={productClientCode}
          productStock={stock}
        />
        {!!(productsRecommended && productsRecommended.length) && this.renderRecommended(productsRecommended)}
      </main>
    );
  }
}

const mapStateToProps = state => ({
  products: state.products.list,
  productsRecommended: state.products.recommended,
  settings: state.settings,
  displayClientDescription: state.contracts.selected && state.contracts.selected.clientDetails.displayClientDescription,
  isAuthenticated: state.auth.authenticated,
  leadTimePermission: state.contracts.selected && state.contracts.selected.leadTimePermission,
  stockPermission: !state.contracts.selected || (state.contracts.selected && state.contracts.selected.stockPermission),
  cartPermission: state.contracts.selected && state.contracts.selected.cartPermission,
  pricePermission: state.contracts.selected && state.contracts.selected.pricePermission,
  opicCodePermission: state.contracts.selected && state.contracts.selected.opicCodePermission,
  soneparCodePermission: state.contracts.selected && state.contracts.selected.soneparCodePermission,
  soneparCodeOff: !!state.settings.soneparCodeOff,
  allowSellSpotItensWithoutStock: state.contracts.selected
    && state.contracts.selected.clientDetails.allowSellSpotItensWithoutStock,
  cartItems: state.cart.items,
  favoritesItems: state.favorites.items,
  opicPhone: state.settings && state.settings.phone,
  isPunchOut: state.punchOut,
  contractId: state.contracts.selected && state.contracts.selected.client.id,
  portfolioGreen: state.settings.portfolioGreen,
});

const mapDispatchToProps = dispatch => ({
  getProduct: (productId, code) => dispatch(getProductDetails(productId, code)),
  getProductsRecommended: force => dispatch(getProductsRecommended(force)),
  addItem: (productId, productClientCode, amount, productCode, mandatoryQuantity) => dispatch(cartAddItem(productId, productClientCode, amount, undefined, undefined, productCode, mandatoryQuantity)),
  addItemCache: (productId, amount, mandatoryQuantity) => dispatch(cartAddItemCache(productId, amount, mandatoryQuantity)),
  setProductsFavorites: (productId, productCode, productClientCode, quantity) => dispatch(setProductsFavorites(productId, productCode, productClientCode, quantity)),
  favoritesRemoveItem: (productId, clientId) => dispatch(favoritesRemoveItem(productId, clientId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ProductPage);
